import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ForexService } from '../../services/forex.service';

@Component({
  selector: 'app-currency-rate',
  templateUrl: './currency-rate.component.html'
})

export class CurrencyRateComponent implements OnInit, OnDestroy {
  @Input() formCurrencyRate: FormControl;
  @Input() formCurrencyRate2: FormControl;
  @Input() baseCurrency;
  @Input() forexCurrency;
  @Input() isFinal: boolean;

  constructor(
    private forexService: ForexService
  ) {
  }

  ngOnInit() {
  
  }

  onRateChange(event, form) {
    const value = parseFloat((event.target as HTMLInputElement).value);
    console.log("currency select", value);
    if (value) {
      const xrate = parseFloat((1 / value).toFixed(4));
      if (form === 1) {
        this.formCurrencyRate2.patchValue(xrate);
      }
      else {
        this.formCurrencyRate.patchValue(xrate);
      }
    }
  }

  getCurrencyRate(currency_base, currency_from, form) {
    console.log('getCurencyRate....');
    
    if (currency_base === currency_from) {
      this.formCurrencyRate.patchValue(1);
      this.formCurrencyRate2.patchValue(1);
      return;
    }
    
    // {
    //   "Realtime Currency Exchange Rate": {
    //       "1. From_Currency Code": "USD",
    //       "2. From_Currency Name": "United States Dollar",
    //       "3. To_Currency Code": "MYR",
    //       "4. To_Currency Name": "Malaysian Ringgit",
    //       "5. Exchange Rate": "4.55800000",
    //       "6. Last Refreshed": "2023-08-07 10:28:02",
    //       "7. Time Zone": "UTC",
    //       "8. Bid Price": "4.55780000",
    //       "9. Ask Price": "4.55810000"
    //   }
    // }
    this.forexService.getCurrencyRate(currency_base, currency_from).subscribe(data => {
      if (data["Error Message"]) {
        console.log(data["Error Message"]);
      }
      else {
        const rate = data["Realtime Currency Exchange Rate"]["5. Exchange Rate"];
        const xrate = parseFloat((1 / rate).toFixed(4));
        if (form === 1) {
          this.formCurrencyRate.patchValue(rate);
          this.formCurrencyRate2.patchValue(xrate);
        }
        else if (form === 2) {
          this.formCurrencyRate2.patchValue(rate);
          this.formCurrencyRate.patchValue(xrate);
        }
      }
    });
  }

  ngOnDestroy() {
    
  }

}
